import PropTypes from 'prop-types';
import React from 'react';

function Sort(props) {
  const { fill } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 7.8L7 3M7 3L2 7.8M7 3L7 14"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M12 16.2L17 21M17 21L22 16.2M17 21L17 10"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  );
}

Sort.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Sort;
